import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrashAlt,
  faExclamationTriangle,
  faCheckCircle,
} from '@fortawesome/pro-light-svg-icons';
import { deleteCampaign } from '../../actions/campaign';

class DeleteCampaignModal extends React.PureComponent {
  deleteCampaign = () => {
    const { campaignToDelete } = this.props;

    deleteCampaign(campaignToDelete);
  };

  close = () => {
    const { closeModal, working } = this.props;
    if (!working) {
      closeModal();
    }
  };

  render() {
    const {
      isOpen,
      campaignToDelete,
      working,
      erroring,
      success,
    } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        toggle={this.close}
        zIndex="100000"
        className="fade-in"
      >
        <ModalHeader>
          {`Delete Campaign ${campaignToDelete?.name}?`}
        </ModalHeader>
        <ModalBody>
          <div>
            <Badge color="warning" className="me-1">WARNING</Badge>
            This is permanent and cannot be undone
          </div>
          <div className="mt-3 px-4">
            <Button
              block
              color="danger"
              onClick={this.deleteCampaign}
              disabled={working || success}
            >
              {working ? (
                <Spinner size="sm" className="me-2" />
              ) : (
                <FontAwesomeIcon icon={faTrashAlt} fixedWidth className="me-2" />
              )}
              {`Delete ${campaignToDelete?.name}`}
            </Button>
          </div>
          {success && (
            <div className="text-success mt-3 px-4">
              <h6>
                <FontAwesomeIcon icon={faCheckCircle} fixedWidth className="me-2" />
                Campaign was successfully deleted.
              </h6>
            </div>
          )}
          {erroring && (
            <div className="text-danger mt-3 px-4">
              <h6>
                <FontAwesomeIcon icon={faExclamationTriangle} fixedWidth className="me-2" />
                Something went wrong.
              </h6>
              This campaign was not deleted. Please try again later or contact support.
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="white" onClick={this.close} disabled={working}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.modals.deleteCampaignOpen,
  campaignToDelete: store.campaign.selectedDeleteCampaign,
  working: store.campaign.deleting,
  erroring: store.campaign.deleteError,
  success: store.campaign.deleteSuccess,
});

const mapDispatchToProps = {
  closeModal: () => ({ type: 'CLOSE_MODAL', modal: 'deleteCampaignOpen' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCampaignModal);
